<template>
    <div class="">
        <div class="c-item" @click="customService">
            <div>
                更换手机号
            </div>
            <i class="iconfont icon-gengduoyonghu"></i>
        </div>
        <div class="footer-info" @click="logoutDialog">
            退出登陆
        </div>
    </div>
</template>

<script>
import { clearCookie } from '@/utils/common.js'
export default {
  name:'my-account',
  data() {
    return {
      
    }
  },
  mounted() {
   
  },
 
  methods: {
    customService(){
      this.$router.push({
        path:'/my/bind'
      })
    },
    async logout(){
      await this.api.login.logout().then(res=>{
        this.$toaster({
          message: res.message,
        })
        if(res.code == 200){
          clearCookie('Authorization')
        }
        this.$router.push({
          path:'/my'
        })
      })
    },
    logoutDialog(){
      let _this = this;
      this.$nextTick(()=>{
        _this.$messageBox({
          title: '确定退出登录',
          subTitle:'下次登录依然可以使用本账号',
          show: true,
          btnType: 2,
          cancelBtnText: '取消',
          confirmBtnText: '退出登录',
          isMobileWx: false,
          confirmCallback: (res) => {
            _this.logout();
          },
          cancelCallback: (res) => {
          },
        })
      })
    }
  },
}
</script>

<style lang="less" scoped>
.c-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 30px 0;
    margin:0 30px;
    border-bottom: 1px solid #eee;
    font-size: 30px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #333333;
    > div {
      display: flex;
      align-items: center;
    }
    .iconfont{
        font-size: 26px;
    }
    img {
      width: 40px;
      height: 40px;
      margin-right: 20px;
    }
  }
  .footer-info{
    position: fixed;
    bottom:0;
    height: 104px;
    border-top: 1px solid #EDEDED;
    font-size: 30px;
    font-family: PingFang-SC-Medium, PingFang-SC;
    color: #EF3510;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
  }
</style>